export default {
    feilopplysninger: {
        tittel: "The personal data about me is incorrect – what do I do?",
        melding: `<p>If your personal data is incorrect, you can request that it be corrected. If your personal
            data is incomplete, you can request that it be supplemented. 
            In special cases, you may have the right to have personal data deleted about yourself, but as
            a rule Nav has a statutory duty to store the information.</p>
            <p>If the personal data is obtained from sources other than Nav, please contact the source provided.</p>
            <p>If the source is Nav, you can use <beskjedLenke>Send message to Nav</beskjedLenke> or contact
            Nav Call and Service Centre, tel. <telefonLenke>55 55 33 33</telefonLenke>.</p>`,
    },
    savneropplysninger: {
        tittel: "Is any of your personal data missing?",
        melding: `<p>This page is under development. It is therefore not certain that you will find all the personal data Nav has about you here. 
            There may be both technical and legal limitations that prevent us from showing personal data. </p>
            <p>If any of your personal data is missing or if Nav has more personal data about you, please use
            <beskjedLenke>Send message to Nav</beskjedLenke> or contact Nav Call and Service Centre,
            tel. <telefonLenke>55 55 33 33</telefonLenke>.</p>`,
    },
    utlevere: {
        tittel: "Disclose information to or collect information from other countries",
        melding: `<p>If you have lived or worked in countries other than Norway and have applied for benefits or services
            in Norway or in another country, Nav must sometimes exchange information about you with another country's social security authorities.
            Nav will only disclose information to countries covered by the EEA Agreement or countries with which
            Norway has entered into social security agreements. </p>
            <p><trygdeavtalerLenke>See overview of the countries with which Norway has entered into a social
            security agreement </trygdeavtalerLenke> (text in norwegian).</p>`,
    },
    klage: {
        tittel: "Do you have questions or would you like to file a complaint?",
        melding: `<p>If you have questions about our processing of your personal data, you can use <beskjedLenke>Send message to Nav</beskjedLenke>
            or contact Nav Call and Service Centre, tel. <telefonLenke>55 55 33 33</telefonLenke>.</p>
            <p>You have the right to complain to the Norwegian Data Protection Authority if you are not satisfied with how we process your
            personal data, or if you believe that the processing is in violation of our privacy policy.
            Information about how to proceed can be found on the website of <datatilsynetLenke>Norwegian
            Data Protection Authority </datatilsynetLenke> (text in norwegian). </p>
            <p>We encourage you to contact Nav before filing a complaint with the Norwegian Data Protection Authority so that we can
            assess your questions and inform you about how we process personal data.</p>`,
    },
    dsop: {
        info:
            "Here you can download a log of information Nav has provided to insurance companies based on your consent given in Altinn. Nav can disclose information because you have given consent, or because Nav is authorized by law. Nav may have disclosed more information than you see in this log." +
            "<br></br><br></br>" +
            "You can read about what information Nav can provide in the <a>privacy statement for Nav</a>. Here you can also read about how to contact Nav if you have questions about your rights and privacy.",
    },
};
